import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useViewport } from 'utils'

// next components

// components
import CollectionSwiperSection from 'components/pages/ArtistProfile/CollectionSwiperSection'
import LoadingComponent from 'pages/profile/LoadingComponent'
import ListingStatusList from 'assets/json/profile-listing-status.json'
import OwnershipList from 'assets/json/profile-ownership.json'
import StudioList from 'assets/json/profile-studio.json'
import TokenTypeList from 'assets/json/profile-token-type.json'
import SortList from 'assets/json/profile-sort.json'

// resources

// styles
import styles from './index.module.scss'

// api
import DashboardAPI from 'apis/dashboard'
import HomeNftCard from 'components/Card/HomeNFTCard'
import LiveAuctionCard from 'components/Card/LiveAuctionCard'
import HomeEditionCard from 'components/Card/HomeEditionCard'
import MobileProfileFilter from 'components/Filter/MobileProfileFilter'
import MobileStudioSort from 'components/Menu/MobileStudioSort'
import OfferSection from 'components/pages/Dashboard/OfferSection'
import ActivitySection from 'components/pages/Dashboard/ActivitySection'
import FavoriteSection from 'components/pages/Dashboard/FavoriteSection'
import HiddenSection from 'components/pages/Dashboard/HiddenSection'
import FilterTab from 'components/Tab/FilterTab'
import ProfileTab from 'components/Tab/ProfileTab'
import NftSkeletonCard from 'components/Card/NftSkeletonCard'

const ProfileTabSection = props => {
  const {
    activeTab,
    collections,
    wallet,
    isOwn,
    handleNextPage,
    isVisibleFetchingCreated,
    isFetchingCreated,
    setIsFetchingCreated,
    refreshing,
    refreshNFT,
    hasLoading,
  } = props
  const hideNftToken = useSelector(state => (state as any).hideNftToken)
  const profileTab = useSelector<any>(state => state.profileTab)
  const dispatch = useDispatch()
  const viewport = useViewport()
  const [isMounted, setIsMounted] = useState(false)
  const [isFetching, setIsFetching] = useState(false)
  const [isVisibleFetching, setIsVisibleFetching] = useState(false)
  const [nftList, setNftList] = useState([])
  const [listingStatusList, setListingStatusList] = useState([])
  const [ownershipList, setOwnershipList] = useState([])
  const [studioList, setStudioList] = useState([])
  const [tokenTypeList, setTokenTypeList] = useState([])
  const [sortList, setSortList] = useState([])
  const [openMobileFilter, setOpenMobileFilter] = useState(false)
  const [openMobileSort, setOpenMobileSort] = useState(false)
  const [loadingData, setLoadingData] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)
  const [favoriteNfts, setFavoriteNfts] = useState([])
  const [favoriteCollections, setFavoriteCollections] = useState([])
  const [hiddenNfts, setHiddenNfts] = useState([])
  const [activityNfts, setActivityNfts] = useState([])
  const [offerNftsMade, setOfferNftsMade] = useState([])
  const [offerNftsReceived, setOfferNftsReceived] = useState([])
  const [showCollectionView, setShowCollectionView] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [shownOfferType, setShownOfferType] = useState<'made' | 'received'>('made')
  const [filterKey, setFilterKey] = useState(null)
  const [favoriteType, setFavoriteType] = useState(0)
  const [artworkSubCateIdx, setArtworkSubCateIdx] = useState(0)
  const [searchKeyword, setSearchKeyword] = useState('')

  useEffect(() => {
    if (hideNftToken.length > 0) {
      let newNfts = nftList.filter(item => item.tokenId !== hideNftToken)
      setNftList(newNfts)
      dispatch({ type: 'set', hideNftToken: '' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hideNftToken])

  useEffect(() => {
    setTimeout(() => {
      setIsMounted(true)
    }, 1000)

    let array: any[] = []
    ListingStatusList.map(item => {
      let object: any = item
      object.checked = false
      array.push(object)
    })
    let listingAll = {
      id: 4,
      name: 'All',
      value: '',
      checked: true,
    }
    array.push(listingAll)
    setListingStatusList(array)

    let array2: any[] = []
    OwnershipList.map(item => {
      let object: any = item
      object.checked = false
      array2.push(object)
    })
    let ownershipAll = {
      id: 2,
      name: 'All',
      value: '',
      checked: true,
    }
    array2.push(ownershipAll)
    if (profileTab === 'created') {
      array2[0].checked = true
      array2[1].checked = false
      array2[2].checked = false
      dispatch({ type: 'set', profileTab: '' })
    }
    setOwnershipList(array2)

    let array3: any[] = []
    StudioList.map(item => {
      let object: any = item
      object.checked = false
      array3.push(object)
    })
    let studioAll = {
      id: 2,
      name: 'All',
      value: '',
      checked: true,
    }
    array3.push(studioAll)
    setStudioList(array3)

    let arrayTokenType: any[] = []
    TokenTypeList.map(item => {
      let object: any = item
      object.checked = false
      arrayTokenType.push(object)
    })
    let ttAll = {
      id: TokenTypeList.length,
      name: 'All',
      value: '',
      checked: true,
    }
    arrayTokenType.push(ttAll)
    setTokenTypeList(arrayTokenType)

    let array4: any[] = []
    SortList.map(item => {
      let object: any = item
      if (object.id === 1) object.checked = true
      else object.checked = false
      array4.push(object)
    })
    setSortList(array4)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (hasLoading) {
      setIsVisibleFetching(true)
      setNftList([])
    }
  }, [hasLoading])

  useEffect(() => {
    if (viewport === 'lg' || viewport === 'xl' || viewport === '2xl') {
      window.scrollTo({
        top: 0,
      })
    }
    if (activeTab === 2) {
      setFilterKey(null)
    }
    setShowFilter(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab])

  const [rowCount, setRowCount] = useState(10)
  const [pages, setPages] = useState(0)

  useEffect(() => {
    setPages(0)
    setTimeout(() => {
      setIsVisibleFetching(true)
      setNftList([])
    }, 500)
  }, [wallet])

  useEffect(() => {
    if (isFetching === true && !loadingData) {
      let nextPage = pages + 1
      getNftItem(nextPage, listingStatusList, ownershipList, studioList, tokenTypeList, sortList, searchKeyword)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetching])

  useEffect(() => {
    if (refreshing === false) {
      setLoadingData(true)
      setTimeout(() => {
        setNftList([])
        getNftItem(1, listingStatusList, ownershipList, studioList, tokenTypeList, sortList, searchKeyword, true)
      }, 500)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshing])

  useEffect(() => {
    if (isFetchingCreated === true) {
      handleNextPage()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetchingCreated])

  const handleListingStatus = index => {
    let array = [...listingStatusList]
    array.map(item => {
      item.checked = false
    })
    array[index].checked = true
    setListingStatusList(array)

    setLoadingData(true)
    setTimeout(() => {
      setNftList([])
      getNftItem(1, array, ownershipList, studioList, tokenTypeList, sortList, searchKeyword, true)
    }, 500)
  }

  const handleOwnership = index => {
    setArtworkSubCateIdx(index)
    let array = [...ownershipList]
    array.map(item => {
      item.checked = false
    })
    if (index >= 0) array[index].checked = true

    setOwnershipList(array)

    // Collections
    if (index === 2) {
      setShowCollectionView(true)
      setLoadingData(false)
      setShowFilter(false)
      return
    }

    // Physical Prints
    if (index === 3) {
      let array = [...studioList]
      array.map(item => {
        item.checked = false
      })
      array[0].checked = true

      setLoadingData(true)
      setTimeout(() => {
        setNftList([])
        setShowCollectionView(false)
        getNftItem(1, listingStatusList, [], array, tokenTypeList, sortList, searchKeyword, true)
      }, 500)
      return
    }

    setLoadingData(true)

    setTimeout(() => {
      setNftList([])
      setShowCollectionView(false)
      getNftItem(1, listingStatusList, array, [], tokenTypeList, sortList, searchKeyword, true)
    }, 500)
  }

  const handleSelectTokenType = index => {
    let array = [...tokenTypeList]
    array.map(item => {
      item.checked = false
    })
    array[index].checked = true
    setTokenTypeList(array)
    setLoadingData(true)
    setTimeout(() => {
      setNftList([])
      getNftItem(1, listingStatusList, ownershipList, studioList, array, sortList, searchKeyword, true)
    }, 500)
  }

  const handleSelectSort = index => {
    let array = [...sortList]
    array.map(item => {
      item.checked = false
    })
    array[index].checked = true
    setSortList(array)
    setLoadingData(true)
    setTimeout(() => {
      setNftList([])
      getNftItem(1, listingStatusList, ownershipList, studioList, tokenTypeList, array, searchKeyword, true)
    }, 100)
  }

  const handleSearch = searchword => {
    setSearchKeyword(searchword)
    setLoadingData(true)
    setTimeout(() => {
      setNftList([])
      getNftItem(1, listingStatusList, ownershipList, studioList, tokenTypeList, sortList, searchword, true)
    }, 500)
  }

  const getNftItem = (
    page,
    listingStatusList,
    ownershipList,
    studioList,
    tokenTypeList,
    sortList,
    searchword,
    reset = false
  ) => {
    let sort = 'price-descending'
    sortList.map(item => {
      if (item.checked === true) {
        sort = item.value
      }
    })

    let params = {
      sort: sort,
      page: page,
      per_page: rowCount.toString(),
    }

    let listingStatus = null
    listingStatusList.map(item => {
      if (item.checked === true) {
        listingStatus = item
      }
    })
    let onlyListed = false
    if (listingStatus?.id === 0 || listingStatus?.id === 2 || listingStatus?.id === 3) {
      params['listing'] = listingStatus.value
      params['per_page'] = 'all'
    } else if (listingStatus?.id === 1) {
      params['listing'] = 'unlisted'
    }

    let ownership = null
    ownershipList.map(item => {
      if (item.checked === true) {
        ownership = item
      }
    })
    if (ownership && ownership.id !== ownershipList.length) {
      params['ownership'] = ownership.value
    }

    let merch = null
    studioList.map(item => {
      if (item.checked === true) {
        merch = item
      }
    })
    if (merch && merch.id !== studioList.length) {
      params['merch_hub'] = merch.value
    }

    let tokenType = null
    tokenTypeList.map(item => {
      if (item.checked === true) {
        tokenType = item
      }
    })
    if (tokenType && tokenType.id !== tokenTypeList.length) {
      params['token_type'] = tokenType.value
    }

    if (searchword.length > 0) {
      params['search'] = searchword
    }

    setIsVisibleFetching(true)

    DashboardAPI.getArtworkList(wallet, params, onlyListed).then(
      response => {
        setLoadingData(false)
        setIsFetching(false)
        setIsLoaded(true)

        let validData = response.filter(item => item.assetUrl.includes('http://') || item.assetUrl.includes('https://'))
        if (reset) setNftList(validData)
        else setNftList([...nftList, ...validData])

        fetchNftData(validData)

        if (validData.length < rowCount) {
          setIsVisibleFetching(false)
        } else {
          setPages(page)
          setIsVisibleFetching(true)
          if (params['per_page'] !== 'all' && validData.length < 5)
            setTimeout(() => {
              setIsFetching(true)
            }, 500)
        }

        if (params['per_page'] === 'all') setIsVisibleFetching(false)
      },
      error => {
        setIsVisibleFetching(false)
        setIsLoaded(true)
      }
    )
  }

  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

  const fetchNftData = nfts => {
    if (nfts.length > 0) {
      ;(async () => {
        for (let index = 0; index < nfts.length; index++) {
          let data = nfts[index]
          fetch(`/nft/${data.tokenId}`).then(e => e.text())
          if (index % 3 == 2) {
            await sleep(1000)
          }
        }
      })()
    }
  }

  const getNoResultText = () => {
    if (artworkSubCateIdx === -1 || artworkSubCateIdx === 0 || artworkSubCateIdx === 1) return 'No artwork found'
    if (artworkSubCateIdx === 2) return 'No collections found'
    if (artworkSubCateIdx === 3) return 'No physical prints available'
  }

  return (
    <div className="w-full lg:min-h-[calc(100vh-140px)]">
      <div className="lg:sticky lg:top-[50px] lg:z-[100]">
        <ProfileTab
          activeTab={activeTab}
          sortList={sortList}
          handleSelectSort={handleSelectSort}
          ownershipList={ownershipList}
          handleOwnership={handleOwnership}
          showFilter={showFilter}
          setShowFilter={setShowFilter}
          openMobileFilter={openMobileFilter}
          setOpenMobileFilter={setOpenMobileFilter}
          shownOfferType={shownOfferType}
          setShownOfferType={setShownOfferType}
          filterKey={filterKey}
          setFilterKey={setFilterKey}
          favoriteType={favoriteType}
          setFavoriteType={setFavoriteType}
          refreshing={refreshing}
          refreshNFT={refreshNFT}
          hasLoading={hasLoading}
        />
      </div>
      <div className="w-full flex min-h-[calc(100vh-300px)]">
        <div className="flex-1">
          {activeTab === 0 &&
            (showCollectionView ? (
              <div className="w-full">
                <CollectionSwiperSection collections={collections} isOwn={isOwn} showFilter={showFilter} />
                {collections.length > 0 && isMounted && isVisibleFetchingCreated && (
                  <LoadingComponent
                    isFetching={isFetchingCreated}
                    setIsFetching={setIsFetchingCreated}
                    text="Loading collections"
                  />
                )}
              </div>
            ) : (
              <div className="">
                <div className="w-full mt-[30px] lg:mt-[18px]">
                  {nftList.length > 0 ? (
                    <div
                      className={`grid sm:grid-cols-2 ${
                        showFilter ? 'lg:grid-cols-2 2xl:grid-cols-3' : 'lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4'
                      } gap-[20px] lg:gap-[10px] xl:gap-[15px] mb-[100px]`}
                    >
                      {nftList.map((item, index) => {
                        return item.auction ? (
                          <LiveAuctionCard
                            data={{
                              token_id: item.tokenId,
                              nft_name: item.nftName,
                              asset_url: item.assetUrl,
                              artist_username: item.artistUsername,
                              asset_type: item.assetType,
                              artist_profile_picture: item.artistProfilePicture,
                              cover_image_url: item.coverImageUrl,
                              current_bid: item.currentBid,
                              reserve_price: item.auction?.reserve_price,
                              start_time: item.auction?.start_time,
                              end_time: item.auction?.end_time,
                              parent_nft: item.parentNft,
                              max_supply: item.maxSupply,
                            }}
                            onClick={() => {}}
                            setCardExpired={item => {}}
                            key={index}
                            isOwn={isOwn}
                          />
                        ) : item.masterEdition ? (
                          <HomeEditionCard
                            data={{
                              tokenId: item.tokenId,
                              nftName: item.nftName,
                              artistUsername: item.artistUsername,
                              artistProfilePicture: item.artistProfilePicture,
                              coverImageUrl: item.coverImageUrl,
                              assetUrl: item.assetUrl,
                              endTime: item.masterEdition?.endTime,
                              startTime: item.masterEdition?.startTime,
                              price: item.masterEdition?.price,
                              currentSupply: item.currentSupply,
                              maxSupply: item.maxSupply,
                            }}
                            type={item.maxSupply === null ? 'open' : 'limit'}
                            onClick={() => {}}
                            key={index}
                            isOwn={isOwn}
                          />
                        ) : (
                          <HomeNftCard
                            image={item.assetUrl}
                            token_id={item.tokenId}
                            nftName={item.nftName}
                            assetType={item.assetType}
                            coverImage={item.coverImageUrl}
                            artistName={item.artistUsername}
                            artistImage={item.artistProfilePicture}
                            collectionName={item.collectionName}
                            price={item.listPrice}
                            parentNft={item.parentNft}
                            isOwn={isOwn}
                            currentSupply={item.currentSupply}
                            maxSupply={item.maxSupply}
                            onClick={() => {}}
                            key={index}
                          />
                        )
                      })}
                    </div>
                  ) : isLoaded && !isVisibleFetching && !loadingData ? (
                    <div className={styles.noArtowrk}>{getNoResultText()}</div>
                  ) : null}
                  {isVisibleFetching &&
                    (nftList.length === 0 && isFetching ? (
                      <div
                        className={`grid sm:grid-cols-2 ${
                          showFilter
                            ? 'lg:grid-cols-2 2xl:grid-cols-3'
                            : 'lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4'
                        } gap-[20px] lg:gap-[10px] xl:gap-[15px]`}
                      >
                        {Array.from({ length: 8 }).map((_, index) => (
                          <div key={index} className="w-full">
                            <NftSkeletonCard />
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="w-full mt-[100px] mb-[100px]">
                        <LoadingComponent
                          isFetching={isFetching}
                          setIsFetching={setIsFetching}
                          text="Loading artworks"
                        />
                      </div>
                    ))}
                </div>
              </div>
            ))}

          {activeTab === 1 && (
            <div className="w-full flex flex-wrap">
              <OfferSection
                shownOfferType={shownOfferType}
                offerNftsMade={offerNftsMade}
                setOfferNftsMade={setOfferNftsMade}
                offerNftsReceived={offerNftsReceived}
                setOfferNftsReceived={setOfferNftsReceived}
              />
            </div>
          )}

          {activeTab === 2 && (
            <div className="w-full flex flex-wrap">
              <ActivitySection
                activityNfts={activityNfts}
                setActivityNfts={setActivityNfts}
                filterKey={filterKey}
                setFilterKey={setFilterKey}
              />
            </div>
          )}
          {activeTab === 3 && (
            <div className="w-full flex flex-wrap">
              <FavoriteSection
                favoriteNfts={favoriteNfts}
                favoriteCollections={favoriteCollections}
                setFavoriteNfts={setFavoriteNfts}
                setFavoriteCollections={setFavoriteCollections}
                favoriteType={favoriteType}
              />
            </div>
          )}
          {activeTab === 4 && (
            <div className="w-full flex flex-wrap">
              <HiddenSection hiddenNfts={hiddenNfts} setHiddenNfts={setHiddenNfts} />
            </div>
          )}
        </div>

        {showFilter && (
          <div
            className="lg:block hidden w-[282px] ml-[37px] mt-[18px] sticky top-[207px]"
            style={{ height: 'fit-content' }}
          >
            <FilterTab
              listingStatusList={listingStatusList}
              handleListingStatus={handleListingStatus}
              tokenTypeList={tokenTypeList}
              handleSelectTokenType={handleSelectTokenType}
              handleSearch={handleSearch}
            />
          </div>
        )}
      </div>

      <div className="flex lg:hidden w-full">
        {openMobileFilter && (
          <MobileProfileFilter
            listingStatus={listingStatusList}
            tokenType={tokenTypeList}
            onFilter={params => {
              let { listingStatus, tokenType } = params
              setListingStatusList(listingStatus)
              setTokenTypeList(tokenType)
              setOpenMobileFilter(false)
              setLoadingData(true)
              setTimeout(() => {
                setNftList([])
                getNftItem(1, listingStatus, ownershipList, studioList, tokenType, sortList, searchKeyword, true)
              }, 100)
            }}
            onClose={() => setOpenMobileFilter(false)}
          />
        )}

        {openMobileSort && (
          <MobileStudioSort
            open={openMobileSort}
            sort={sortList}
            onSort={params => {
              setSortList(params)
              setOpenMobileSort(false)
              setLoadingData(true)
              setTimeout(() => {
                setNftList([])
                getNftItem(1, listingStatusList, ownershipList, studioList, tokenTypeList, params, searchKeyword, true)
              }, 100)
            }}
            onClose={() => setOpenMobileSort(false)}
          />
        )}
      </div>
    </div>
  )
}

export default ProfileTabSection
